import { useCallback } from "react";

import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import ButtonIcon from "ds/components/ButtonIcon";
import { Star, StarFilled } from "components/icons/generated";
import useSetModuleFavorite from "shared/Module/useSetModuleFavorite";
import { canAccessModule } from "views/Account/ModulesNew/helpers";

import { ANALYTICS } from "../../../constants";
import styles from "./styles.module.css";

const REFETCH_QUERIES = ["SearchModulesNew", "SearchModulesSuggestionsNew"];

const ModulesTableFavoriteCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const isDisabled = !canAccessModule(module);
  const [setModuleFavorite] = useSetModuleFavorite({
    refetchQueries: REFETCH_QUERIES,
  });

  const handleStarModule = useCallback(
    (clb?: () => void) => () => {
      setModuleFavorite({ id: module.id, star: !module.starred });
      clb?.();
    },
    [setModuleFavorite, module.id, module.starred]
  );

  return (
    <TableSimpleCell {...cellProps}>
      <ButtonIcon
        {...ANALYTICS}
        analyticsTitle={"Star clicked"}
        analyticsProps={{
          value: module.starred ? "remove" : "add",
        }}
        className={styles.favoriteButtonIcon}
        icon={module.starred ? StarFilled : Star}
        onPress={handleStarModule()}
        variant="ghost"
        disabled={isDisabled}
      >
        {module.starred ? "Remove from favorites" : "Add to favorites"}
      </ButtonIcon>
    </TableSimpleCell>
  );
};

export default ModulesTableFavoriteCell;
